import { Button, Modal, ModalBody } from "reactstrap";

export default function ModalSelecaoGrupoItem({ config, onClosed, onSelect }) {
  return (
    <Modal isOpen={!!config} onClosed={onClosed}>
      <ModalBody>
        <h2>O que gostaria de criar?</h2>
        <div className="d-flex flex-row" style={{ gap: 10 }}>
          <div className="flex-grow-1"><Button color="primary" block onClick={() => onSelect && onSelect('grupo', { ...config.pai })}>Grupo</Button></div>
          <div className="flex-grow-1"><Button color="primary" block onClick={() => onSelect && onSelect('item', { ...config.pai })}>Item</Button></div>
        </div>
      </ModalBody>
    </Modal>
  )
}